// extracted by mini-css-extract-plugin
export default {"magicButtonSize":"ReviewRedirectionChapName_magicButtonSize__KAqqA","language":"ReviewRedirectionChapName_language__1zggJ"};